var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_234)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_16_234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.3492 67.6714L54.9339 49.9997L86.3492 32.3279C86.8299 32.0345 87.178 31.566 87.3202 31.0211C87.4624 30.4761 87.3875 29.8972 87.1114 29.4064C86.8353 28.9155 86.3794 28.551 85.8398 28.3896C85.3002 28.2281 84.7191 28.2824 84.2187 28.541L52.6753 46.2844V10.8692C52.6753 10.2927 52.4462 9.73972 52.0385 9.33204C51.6308 8.92435 51.0779 8.69531 50.5013 8.69531C49.9248 8.69531 49.3718 8.92435 48.9642 9.33204C48.5565 9.73972 48.3274 10.2927 48.3274 10.8692V46.2844L16.784 28.541C16.2836 28.2824 15.7024 28.2281 15.1629 28.3896C14.6233 28.551 14.1674 28.9155 13.8913 29.4064C13.6151 29.8972 13.5403 30.4761 13.6825 31.0211C13.8246 31.566 14.1728 32.0345 14.6535 32.3279L46.0687 49.9997L14.6535 67.6714C14.2353 67.9073 13.9069 68.275 13.7197 68.7172C13.5324 69.1594 13.4969 69.6511 13.6185 70.1156C13.7402 70.5801 14.0122 70.9913 14.3921 71.2849C14.7721 71.5786 15.2386 71.7382 15.7187 71.7388C16.0914 71.7393 16.4578 71.6427 16.7818 71.4583L48.3274 53.7149V89.1301C48.3274 89.7066 48.5565 90.2596 48.9642 90.6673C49.3718 91.075 49.9248 91.304 50.5013 91.304C51.0779 91.304 51.6308 91.075 52.0385 90.6673C52.4462 90.2596 52.6753 89.7066 52.6753 89.1301V53.7149L84.2187 71.4583C84.5433 71.643 84.9105 71.7397 85.284 71.7388C85.7643 71.7386 86.2311 71.5794 86.6114 71.2859C86.9917 70.9925 87.2641 70.5813 87.386 70.1167C87.508 69.652 87.4726 69.1601 87.2854 68.7177C87.0982 68.2753 86.7676 67.9074 86.3492 67.6714Z",
    fill: "url(#paint0_linear_16_234)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bi_16_234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.4999 60.87C48.3501 60.87 46.2486 60.2325 44.4611 59.0381C42.6736 57.8438 41.2805 56.1462 40.4578 54.16C39.6351 52.1739 39.4198 49.9884 39.8392 47.8799C40.2586 45.7714 41.2939 43.8346 42.814 42.3145C44.3341 40.7944 46.2709 39.7591 48.3794 39.3397C50.4879 38.9203 52.6734 39.1356 54.6595 39.9583C56.6457 40.781 58.3433 42.1741 59.5377 43.9616C60.732 45.7491 61.3695 47.8506 61.3695 50.0004C61.3661 52.8822 60.2198 55.6449 58.1821 57.6826C56.1444 59.7203 53.3817 60.8665 50.4999 60.87Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4999 60.87C48.3501 60.87 46.2486 60.2325 44.4611 59.0381C42.6736 57.8438 41.2805 56.1462 40.4578 54.16C39.6351 52.1739 39.4198 49.9884 39.8392 47.8799C40.2586 45.7714 41.2939 43.8346 42.814 42.3145C44.3341 40.7944 46.2709 39.7591 48.3794 39.3397C50.4879 38.9203 52.6734 39.1356 54.6595 39.9583C56.6457 40.781 58.3433 42.1741 59.5377 43.9616C60.732 45.7491 61.3695 47.8506 61.3695 50.0004C61.3661 52.8822 60.2198 55.6449 58.1821 57.6826C56.1444 59.7203 53.3817 60.8665 50.4999 60.87Z",
    fill: "url(#paint1_linear_16_234)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1278 58.0404C46.7176 59.1026 48.5865 59.6697 50.4985 59.67L45.1278 58.0404ZM45.1278 58.0404C43.5377 56.9779 42.2983 55.4677 41.5664 53.7008M45.1278 58.0404L41.5664 53.7008M41.5664 53.7008C40.8346 51.9339 40.6431 49.9897 41.0162 48.114M41.5664 53.7008L41.0162 48.114M41.0162 48.114C41.3893 46.2383 42.3102 44.5153 43.6625 43.163M41.0162 48.114L43.6625 43.163M43.6625 43.163C45.0148 41.8107 46.7378 40.8898 48.6135 40.5167M43.6625 43.163L48.6135 40.5167M48.6135 40.5167C50.4892 40.1436 52.4334 40.335 54.2003 41.0669M48.6135 40.5167L54.2003 41.0669M54.2003 41.0669C55.9672 41.7988 57.4774 43.0382 58.5399 44.6283M54.2003 41.0669L58.5399 44.6283M58.5399 44.6283C59.6021 46.2181 60.1692 48.087 60.1695 49.999L58.5399 44.6283ZM60.1695 49.9991C60.1664 52.563 59.1465 55.0211 57.3335 56.834C55.5206 58.647 53.0625 59.6669 50.4986 59.67L60.1695 49.9991Z",
    stroke: "url(#paint2_linear_16_234)",
    strokeOpacity: 0.1,
    strokeWidth: 2.4
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bi_16_234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.2824 41.3036C91.2855 41.3036 96.152 36.4371 96.152 30.434C96.152 24.4309 91.2855 19.5645 85.2824 19.5645C79.2793 19.5645 74.4128 24.4309 74.4128 30.434C74.4128 36.4371 79.2793 41.3036 85.2824 41.3036Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2824 41.3036C91.2855 41.3036 96.152 36.4371 96.152 30.434C96.152 24.4309 91.2855 19.5645 85.2824 19.5645C79.2793 19.5645 74.4128 24.4309 74.4128 30.434C74.4128 36.4371 79.2793 41.3036 85.2824 41.3036Z",
    fill: "url(#paint3_linear_16_234)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.952 30.434C94.952 35.7744 90.6228 40.1036 85.2824 40.1036C79.9421 40.1036 75.6128 35.7744 75.6128 30.434C75.6128 25.0937 79.9421 20.7645 85.2824 20.7645C90.6228 20.7645 94.952 25.0937 94.952 30.434Z",
    stroke: "url(#paint4_linear_16_234)",
    strokeOpacity: 0.1,
    strokeWidth: 2.4
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_16_234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.2826 71.74C84.706 71.74 84.1531 71.5109 83.7454 71.1033C83.3377 70.6956 83.1086 70.1426 83.1086 69.5661V30.4356C83.1086 29.8591 83.3377 29.3061 83.7454 28.8984C84.1531 28.4908 84.706 28.2617 85.2826 28.2617C85.8591 28.2617 86.4121 28.4908 86.8197 28.8984C87.2274 29.3061 87.4565 29.8591 87.4565 30.4356V69.5661C87.4565 70.1426 87.2274 70.6956 86.8197 71.1033C86.4121 71.5109 85.8591 71.74 85.2826 71.74Z",
    fill: "url(#paint5_linear_16_234)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_bi_16_234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.2824 80.4344C91.2855 80.4344 96.152 75.568 96.152 69.5649C96.152 63.5618 91.2855 58.6953 85.2824 58.6953C79.2793 58.6953 74.4128 63.5618 74.4128 69.5649C74.4128 75.568 79.2793 80.4344 85.2824 80.4344Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2824 80.4344C91.2855 80.4344 96.152 75.568 96.152 69.5649C96.152 63.5618 91.2855 58.6953 85.2824 58.6953C79.2793 58.6953 74.4128 63.5618 74.4128 69.5649C74.4128 75.568 79.2793 80.4344 85.2824 80.4344Z",
    fill: "url(#paint6_linear_16_234)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.952 69.5649C94.952 74.9052 90.6228 79.2344 85.2824 79.2344C79.9421 79.2344 75.6128 74.9052 75.6128 69.5649C75.6128 64.2245 79.9421 59.8953 85.2824 59.8953C90.6228 59.8953 94.952 64.2245 94.952 69.5649Z",
    stroke: "url(#paint7_linear_16_234)",
    strokeOpacity: 0.1,
    strokeWidth: 2.4
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_16_234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.4992 91.3049C50.0189 91.3048 49.5521 91.1455 49.1718 90.8521C48.7915 90.5586 48.5191 90.1474 48.3971 89.6828C48.2752 89.2182 48.3106 88.7262 48.4978 88.2838C48.685 87.8415 49.0134 87.4735 49.4318 87.2375L84.2144 67.6723C84.7148 67.4138 85.296 67.3595 85.8355 67.5209C86.3751 67.6823 86.831 68.0469 87.1071 68.5377C87.3832 69.0286 87.4581 69.6074 87.3159 70.1524C87.1738 70.6974 86.8256 71.1659 86.3449 71.4593L51.5623 91.0245C51.2383 91.2088 50.8719 91.3054 50.4992 91.3049Z",
    fill: "url(#paint8_linear_16_234)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_bi_16_234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.4999 100.001C56.503 100.001 61.3695 95.1344 61.3695 89.1313C61.3695 83.1282 56.503 78.2617 50.4999 78.2617C44.4968 78.2617 39.6304 83.1282 39.6304 89.1313C39.6304 95.1344 44.4968 100.001 50.4999 100.001Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4999 100.001C56.503 100.001 61.3695 95.1344 61.3695 89.1313C61.3695 83.1282 56.503 78.2617 50.4999 78.2617C44.4968 78.2617 39.6304 83.1282 39.6304 89.1313C39.6304 95.1344 44.4968 100.001 50.4999 100.001Z",
    fill: "url(#paint9_linear_16_234)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1695 89.1313C60.1695 94.4716 55.8403 98.8009 50.4999 98.8009C45.1596 98.8009 40.8304 94.4716 40.8304 89.1313C40.8304 83.7909 45.1596 79.4617 50.4999 79.4617C55.8403 79.4617 60.1695 83.7909 60.1695 89.1313Z",
    stroke: "url(#paint10_linear_16_234)",
    strokeOpacity: 0.1,
    strokeWidth: 2.4
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_16_234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.4985 91.3049C50.1257 91.3054 49.7593 91.2088 49.4354 91.0245L14.6528 71.4593C14.1721 71.1659 13.8239 70.6974 13.6817 70.1524C13.5396 69.6074 13.6144 69.0286 13.8906 68.5377C14.1667 68.0469 14.6226 67.6823 15.1622 67.5209C15.7017 67.3595 16.2829 67.4138 16.7832 67.6723L51.5658 87.2375C51.9842 87.4735 52.3127 87.8415 52.4999 88.2838C52.6871 88.7262 52.7225 89.2182 52.6005 89.6828C52.4786 90.1474 52.2062 90.5586 51.8259 90.8521C51.4456 91.1455 50.9788 91.3048 50.4985 91.3049Z",
    fill: "url(#paint11_linear_16_234)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_bi_16_234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7172 80.4344C21.7203 80.4344 26.5868 75.568 26.5868 69.5649C26.5868 63.5618 21.7203 58.6953 15.7172 58.6953C9.71413 58.6953 4.84766 63.5618 4.84766 69.5649C4.84766 75.568 9.71413 80.4344 15.7172 80.4344Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7172 80.4344C21.7203 80.4344 26.5868 75.568 26.5868 69.5649C26.5868 63.5618 21.7203 58.6953 15.7172 58.6953C9.71413 58.6953 4.84766 63.5618 4.84766 69.5649C4.84766 75.568 9.71413 80.4344 15.7172 80.4344Z",
    fill: "url(#paint12_linear_16_234)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3868 69.5649C25.3868 74.9052 21.0576 79.2344 15.7172 79.2344C10.3769 79.2344 6.04766 74.9052 6.04766 69.5649C6.04766 64.2245 10.3769 59.8953 15.7172 59.8953C21.0576 59.8953 25.3868 64.2245 25.3868 69.5649Z",
    stroke: "url(#paint13_linear_16_234)",
    strokeOpacity: 0.1,
    strokeWidth: 2.4
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_i_16_234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7174 71.74C15.1408 71.74 14.5879 71.5109 14.1802 71.1033C13.7725 70.6956 13.5435 70.1426 13.5435 69.5661V30.4356C13.5435 29.8591 13.7725 29.3061 14.1802 28.8984C14.5879 28.4908 15.1408 28.2617 15.7174 28.2617C16.2939 28.2617 16.8469 28.4908 17.2546 28.8984C17.6622 29.3061 17.8913 29.8591 17.8913 30.4356V69.5661C17.8913 70.1426 17.6622 70.6956 17.2546 71.1033C16.8469 71.5109 16.2939 71.74 15.7174 71.74Z",
    fill: "url(#paint14_linear_16_234)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_bi_16_234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7172 41.3036C21.7203 41.3036 26.5868 36.4371 26.5868 30.434C26.5868 24.4309 21.7203 19.5645 15.7172 19.5645C9.71413 19.5645 4.84766 24.4309 4.84766 30.434C4.84766 36.4371 9.71413 41.3036 15.7172 41.3036Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7172 41.3036C21.7203 41.3036 26.5868 36.4371 26.5868 30.434C26.5868 24.4309 21.7203 19.5645 15.7172 19.5645C9.71413 19.5645 4.84766 24.4309 4.84766 30.434C4.84766 36.4371 9.71413 41.3036 15.7172 41.3036Z",
    fill: "url(#paint15_linear_16_234)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3868 30.434C25.3868 35.7744 21.0576 40.1036 15.7172 40.1036C10.3769 40.1036 6.04766 35.7744 6.04766 30.434C6.04766 25.0937 10.3769 20.7645 15.7172 20.7645C21.0576 20.7645 25.3868 25.0937 25.3868 30.434Z",
    stroke: "url(#paint16_linear_16_234)",
    strokeOpacity: 0.1,
    strokeWidth: 2.4
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_i_16_234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7168 32.6091C15.2364 32.6089 14.7696 32.4497 14.3893 32.1562C14.009 31.8628 13.7366 31.4516 13.6147 30.987C13.4927 30.5223 13.5281 30.0304 13.7153 29.588C13.9025 29.1456 14.231 28.7777 14.6494 28.5417L49.432 8.97646C49.6812 8.82436 49.9585 8.72403 50.2474 8.68145C50.5362 8.63886 50.8307 8.65491 51.1132 8.72861C51.3957 8.80232 51.6605 8.93219 51.8917 9.11046C52.123 9.28873 52.3159 9.51176 52.4591 9.76623C52.6022 10.0207 52.6927 10.3014 52.725 10.5916C52.7573 10.8818 52.7308 11.1755 52.6471 11.4552C52.5634 11.7349 52.4243 11.9949 52.2379 12.2197C52.0515 12.4445 51.8218 12.6294 51.5624 12.7634L16.7798 32.3286C16.4559 32.5129 16.0895 32.6096 15.7168 32.6091Z",
    fill: "url(#paint17_linear_16_234)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_bi_16_234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.4999 21.7391C56.503 21.7391 61.3695 16.8727 61.3695 10.8696C61.3695 4.86647 56.503 0 50.4999 0C44.4968 0 39.6304 4.86647 39.6304 10.8696C39.6304 16.8727 44.4968 21.7391 50.4999 21.7391Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4999 21.7391C56.503 21.7391 61.3695 16.8727 61.3695 10.8696C61.3695 4.86647 56.503 0 50.4999 0C44.4968 0 39.6304 4.86647 39.6304 10.8696C39.6304 16.8727 44.4968 21.7391 50.4999 21.7391Z",
    fill: "url(#paint18_linear_16_234)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1695 10.8696C60.1695 16.2099 55.8403 20.5391 50.4999 20.5391C45.1596 20.5391 40.8304 16.2099 40.8304 10.8696C40.8304 5.52921 45.1596 1.2 50.4999 1.2C55.8403 1.2 60.1695 5.52921 60.1695 10.8696Z",
    stroke: "url(#paint19_linear_16_234)",
    strokeOpacity: 0.1,
    strokeWidth: 2.4
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_i_16_234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.1073 23.3444L51.5659 8.97699C51.0656 8.71844 50.4844 8.66416 49.9449 8.82559C49.4053 8.98701 48.9494 9.35154 48.6733 9.8424C48.3971 10.3333 48.3223 10.9121 48.4645 11.4571C48.6066 12.002 48.9548 12.4706 49.4355 12.7639L74.979 27.1335C75.4236 25.739 76.1478 24.4497 77.1073 23.3444Z",
    fill: "url(#paint20_linear_16_234)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_16_234",
    x: 13.5476,
    y: 8.69531,
    width: 73.9096,
    height: 98.6086,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_16_234"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bi_16_234",
    x: -8.36963,
    y: -8.86914,
    width: 117.739,
    height: 117.739,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_16_234"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_16_234",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_16_234"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bi_16_234",
    x: 26.4128,
    y: -28.4355,
    width: 117.739,
    height: 117.739,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_16_234"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_16_234",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_16_234"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_16_234",
    x: 83.1086,
    y: 28.2617,
    width: 4.34784,
    height: 59.4783,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_16_234"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_bi_16_234",
    x: 26.4128,
    y: 10.6953,
    width: 117.739,
    height: 117.739,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_16_234"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_16_234",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_16_234"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_16_234",
    x: 48.3259,
    y: 67.4297,
    width: 39.0604,
    height: 39.8752,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_16_234"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_bi_16_234",
    x: -8.36963,
    y: 30.2617,
    width: 117.739,
    height: 117.739,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_16_234"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_16_234",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_16_234"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_16_234",
    x: 13.6113,
    y: 67.4297,
    width: 39.0604,
    height: 39.8752,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_16_234"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_bi_16_234",
    x: -43.1523,
    y: 10.6953,
    width: 117.739,
    height: 117.739,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_16_234"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_16_234",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_16_234"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_16_234",
    x: 13.5435,
    y: 28.2617,
    width: 4.34784,
    height: 59.4783,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_16_234"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_bi_16_234",
    x: -43.1523,
    y: -28.4355,
    width: 117.739,
    height: 117.739,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_16_234"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_16_234",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_16_234"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_i_16_234",
    x: 13.5435,
    y: 8.6582,
    width: 39.1949,
    height: 39.9509,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_16_234"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_bi_16_234",
    x: -8.36963,
    y: -48,
    width: 117.739,
    height: 117.739,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_16_234"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_16_234",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_16_234"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_i_16_234",
    x: 48.394,
    y: 8.73438,
    width: 28.7132,
    height: 34.3992,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_16_234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16_234",
    x1: 13.5476,
    y1: 8.69531,
    x2: 46.3423,
    y2: 45.5806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16_234",
    x1: 39.6304,
    y1: 39.1309,
    x2: 65.2384,
    y2: 45.6332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16_234",
    x1: 40.3097,
    y1: 40.119,
    x2: 61.3695,
    y2: 40.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_16_234",
    x1: 74.4128,
    y1: 19.5645,
    x2: 100.021,
    y2: 26.0668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_16_234",
    x1: 75.0922,
    y1: 20.5526,
    x2: 96.152,
    y2: 20.5526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_16_234",
    x1: 83.1086,
    y1: 28.2617,
    x2: 87.4103,
    y2: 28.8025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_16_234",
    x1: 74.4128,
    y1: 58.6953,
    x2: 100.021,
    y2: 65.1977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_16_234",
    x1: 75.0922,
    y1: 59.6835,
    x2: 96.152,
    y2: 59.6835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_16_234",
    x1: 48.3259,
    y1: 67.4297,
    x2: 55.8322,
    y2: 82.8675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_16_234",
    x1: 39.6304,
    y1: 78.2617,
    x2: 65.2384,
    y2: 84.7641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_16_234",
    x1: 40.3097,
    y1: 79.2499,
    x2: 61.3695,
    y2: 79.2499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_16_234",
    x1: 13.6113,
    y1: 67.4297,
    x2: 21.1176,
    y2: 82.8675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_16_234",
    x1: 4.84766,
    y1: 58.6953,
    x2: 30.4557,
    y2: 65.1977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_16_234",
    x1: 5.527,
    y1: 59.6835,
    x2: 26.5868,
    y2: 59.6835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_16_234",
    x1: 13.5435,
    y1: 28.2617,
    x2: 17.8451,
    y2: 28.8025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_16_234",
    x1: 4.84766,
    y1: 19.5645,
    x2: 30.4557,
    y2: 26.0668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_16_234",
    x1: 5.527,
    y1: 20.5526,
    x2: 26.5868,
    y2: 20.5526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_16_234",
    x1: 13.5435,
    y1: 8.6582,
    x2: 21.0722,
    y2: 24.1465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_16_234",
    x1: 39.6304,
    y1: 0,
    x2: 65.2384,
    y2: 6.50235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_16_234",
    x1: 40.3097,
    y1: 0.988143,
    x2: 61.3695,
    y2: 0.988143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_16_234",
    x1: 48.394,
    y1: 8.73438,
    x2: 54.3456,
    y2: 20.4102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodes);
export default __webpack_public_path__ + "static/media/nodes.6796dab9a39abcc1ea02f8f0ba07f572.svg";
export { ForwardRef as ReactComponent };